function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.109,
    height: 19.996,
    viewBox: "0 0 4.262 5.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#00caff",
      fillRule: "nonzero"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.647 14.998H5.057a1 1 0 0 1 0-2h15.59l-5.3-5.3a1 1 0 1 1 1.42-1.4l7 7a1 1 0 0 1 0 1.4l-7 7a1 1 0 1 1-1.42-1.4l5.31-5.3z",
    style: {
      fill: "#ee3b77",
      fillOpacity: 1
    },
    transform: "matrix(0 .26458 -.26458 0 5.835 -1.073)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowNegative);
export default __webpack_public_path__ + "static/media/down-arrow-negative.7bbae39e1857601bf634ca990c511865.svg";
export { ForwardRef as ReactComponent };